import React, { useState } from 'react';
import { apiString as api } from '../utils/constants';
import axios from 'axios';

const HealthPlanContext = React.createContext<any>(null);

export const HealthPlanProvider = ({ children }: { children: React.ReactNode }) => {
    const [healthPlan, setHealthPlan] = useState<any>({});
    const [healthPlans, setHealthPlans] = useState<any[]>([]);

    const getHealthPlans = async () => {
        try {
            const response = await axios.get(`${api}/managehealthplan/gethealthplans`);
            setHealthPlans(response.data);
        } catch (error) {
            console.error(error);
        }
    };

    const value = { healthPlan, setHealthPlan, healthPlans, getHealthPlans, setHealthPlans };

    return <HealthPlanContext.Provider value={value}>{children}</HealthPlanContext.Provider>;
};

export const useHealthPlanContext = () => React.useContext(HealthPlanContext);

